import React, { useState, useEffect } from "react";
import { Alert, Box, Collapse } from "@mui/material";
import WifiOffIcon from "@mui/icons-material/WifiOff";

const NetworkStatus: React.FC = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        pointerEvents: "none",
      }}
    >
      <Collapse in={!isOnline}>
        <Alert
          severity="error"
          icon={<WifiOffIcon fontSize="inherit" />}
          sx={{
            width: "100%",
            borderRadius: 0,
            justifyContent: "center",
            fontWeight: "bold",
            pointerEvents: "auto",
            animation: "pulse 2s infinite",
            "@keyframes pulse": {
              "0%": {
                opacity: 1,
              },
              "50%": {
                opacity: 0.8,
              },
              "100%": {
                opacity: 1,
              },
            },
          }}
        >
          Network Connection Error: Please check your internet connection.
        </Alert>
      </Collapse>
    </Box>
  );
};

export default NetworkStatus;
